import { type z } from 'zod'

import { type schemas } from '~interface/zod-schema'

export enum Medium {
  ViaSite = 'ViaSite',
  ViaPhone = 'ViaPhone',
  ViaEmail = 'ViaEmail',
  ViaInPerson = 'ViaInPerson',
}

export type CreateMessageViewRequestData = z.infer<typeof schemas.CreateMessageViewRequestData>
export type CreateMessageViewResponseData = z.infer<typeof schemas.CreateMessageViewResponseData>

export type DeleteTemplateViewRequestData = z.infer<typeof schemas.DeleteTemplateViewRequestData>

export type ImportEmailViewRequestData = z.infer<typeof schemas.ImportEmailViewRequestData>
export type ImportEmailViewResponseData = z.infer<typeof schemas.ImportEmailViewResponseData>

export type ListTemplatesViewRequestData = z.infer<typeof schemas.ListTemplatesViewRequestData>
export type ListTemplatesViewResponseData = z.infer<typeof schemas.ListTemplatesViewResponseData>

export type UpsertTemplateViewRequestData = z.infer<typeof schemas.UpsertTemplateViewRequestData>
export type UpsertTemplateViewResponseData = z.infer<typeof schemas.UpsertTemplateViewResponseData>

export type Attachment = z.infer<typeof schemas.Attachment>
export type MessageTemplate0 = z.infer<typeof schemas.MessageTemplate0>
